import { TripBookingPayment } from '../../lib/types/models/trip-booking/trip-booking-payment'
import { TripBookingPaymentInput } from '../../lib/types/models/trip-booking/trip-booking-payment-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTripBookingPayment(
  input: TripBookingPaymentInput & { tripBookingId: number }
) {
  const { tripBookingId, ...data } = input
  return restApiClient
    .url(constructApiUrl(API['trip-bookings'].createPayment.url, { id: tripBookingId }))
    .post<TripBookingPayment, TripBookingPaymentInput>(data)
}
